import React from "react";
// import { Accordion, Nav } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Logo from "./../../assets/img/logo.png";
import { connect } from "react-redux";
import {
  Home,
  Portrait,
  Today,
  ContactMail,
  Assignment,
  Subtitles,
  LocalShipping,
  AccountBox,
  ExpandMore,
  Equalizer,
  SupervisedUserCircle,
  Assessment,
  CardMembership,
  AccessTime,
  AttachMoney,
  Description,
  Palette,
  Settings,
  CreditCard,
} from "@material-ui/icons";
import {
  AcUnitRounded,
  Policy,
  ManageAccounts,
  EventAvailable,
} from "@mui/icons-material";
import { NavLink, useLocation } from "react-router-dom";
import { cryptoTokenDecode } from "./../Common/Common";
import * as message from "./../../config/CommonMessages";
import * as code from "./../../config/Constants";
import urls from "./../../config/UrlConstants";
import { AccordionDetails, AccordionSummary, Accordion, Link } from "@material-ui/core";
import { getallpermissions } from "../../actions/UserActions";
import { setRenderHeader } from "../../actions/rerander";
import { getBillingItemForpermissions } from "../../actions/BillingActions";
import { getCurrentSystemVersionAction } from "../../actions/SystemVersionAction";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants";
import moment from "moment";
import { toastMessage } from "../Common/Common";
import { useHistory } from "react-router-dom";
var CryptoJS = require("crypto-js");

function Sidebar({
  getallpermissions,
  getBillingItemForpermissions,
  getCurrentSystemVersionAction,
  miniActive,
  rerander,
  renderSidebar,
  setRenderHeader,
  renderHeader,
}) {
  const [permission, setPermission] = React.useState("");
  const [permissionArray, setPermissionArray] = React.useState([]);
  const [userType, setUsertype] = React.useState(
    localStorage.getItem("usertype")
  );
  const [vendorRoleName, setVendorRoleName] = React.useState(
    localStorage.getItem("vendorRoleName")
  );
  const [billingItem, setBillingItem] = React.useState([]);
  const [version, setVersion] = React.useState("");
  const [link, setLink] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();
  const location = useLocation();
  React.useEffect(() => {
    let Userdata = cryptoTokenDecode();
    // console.log("data1212", data);
    // console.log("======props39", renderSidebar);
    // console.log("======props39", typeof renderSidebar);
    let usertype = localStorage.getItem("usertype");
    setUsertype(usertype);
    if (usertype === "VENDOR") {
      getallpermissions().then((res) => {
        if (res.data) {
          localStorage.setItem("otherInfo", res.data);
          setPermission(res.data);
          let bytes = CryptoJS.AES.decrypt(
            res.data,
            REACT_APP_CRYPTO_SECRET_KEY
          );
          let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          //console.log("decryptedData39", decryptedData);
          let permissionarray = decryptedData.split(",");
          //console.log("permissionarray", permissionarray);
          setPermissionArray(permissionarray);
          //chcking owner have plan item to use ai
          const today = moment();
          let data = {
            userId: localStorage.getItem("ownerId"),
            invoicePeriod: today.format("YYYYMM"),
          };
          // console.log("data", data);
          getBillingItemForpermissions(data).then((res) => {
            if (res.status === 200) {
              setBillingItem(res.data);
              permissionarray.push(...res.data);
              // console.log("permissionarray-95", permissionarray);
              if (!res.data.includes("aiimagetool")) {
                const index = permissionarray.indexOf("manage_image_ai");
                if (index > -1) {
                  // only splice array when item is found
                  permissionarray.splice(index, 1); // 2nd parameter means remove one item only
                }
              }
              if (!res.data.includes("manage_image_ai")) {
                const index = permissionarray.indexOf("aiimagetool");
                if (index > -1) {
                  // only splice array when item is found
                  permissionarray.splice(index, 1); // 2nd parameter means remove one item only
                }
              }
              // console.log("permissionarray-103", permissionarray);
              let cipherValue = CryptoJS.AES.encrypt(
                permissionarray.join(","),
                REACT_APP_CRYPTO_SECRET_KEY
              ).toString();
              localStorage.setItem("otherInfo", cipherValue);
            }
          });
        }
      });
    } else if (usertype === "ACCTOWNER") {
      // const today = moment();
      // let data = {
      //   userId: Userdata._id,
      //   invoicePeriod: today.format("YYYYMM"),
      // };
      // getBillingItemForpermissions(data).then((res) => {
      //   if (res.status === 200) {
      //     setBillingItem(res.data);
      //     let cipherValue = CryptoJS.AES.encrypt(
      //       res.data.join(","),
      //       REACT_APP_CRYPTO_SECRET_KEY
      //     ).toString();
      //     localStorage.setItem("otherInfo", cipherValue);
      //   }
      // });
    }
    setRenderHeader(Math.random());
    // getSystemVersion();
    setTimeout(() => {
      setVersion(localStorage.getItem("systemVersion"));
      setLink(localStorage.getItem("systemVersionLink"));
    }, 1000);

  }, [rerander, renderSidebar]);

  function getSystemVersion() {
    getCurrentSystemVersionAction().then((res) => {
      if (res.status === 200 && res.data.length > 0) {
        // console.log("res.data", res.data);
        setVersion(res.data[0].version);
        if (res.data[0].referenceLink != "https://www.") {
          setLink(res.data[0].referenceLink);
        }
      }
    });
  }

  const handleNavClick = () => {
     setLoading(true);
    const today = moment();
    let Userdata = cryptoTokenDecode();
    let data = {
      userId: Userdata._id,
      invoicePeriod: today.format("YYYYMM"),
    };
    getBillingItemForpermissions(data).then((res) => {
      if (res.status === 200) {
        setBillingItem(res.data);
        let cipherValue = CryptoJS.AES.encrypt(
          res.data.join(","),
          REACT_APP_CRYPTO_SECRET_KEY
        ).toString();
        localStorage.setItem("otherInfo", cipherValue);
        setLoading(false);
        // console.log("res.data", res.data);
        // console.log("message.aiimagetool", message.aiimagetool);
        if (
          res.data.length > 0 &&
          [message.aiimagetool].some((item) => res.data.includes(item))
        ) {
          history.push("/generateImage");
        } else {
          history.push("/generateImage-AccessDenied");
        }

      }
       setLoading(false);
    });

  };
  function checkPermission(checkFor) {
    // console.log("permissionArray", permissionArray);
    // console.log("checkFor", checkFor);
    const hasSome =
      permissionArray &&
      permissionArray.length > 0 &&
      checkFor.some((item) => permissionArray.includes(item));
    return hasSome;
  }

  function checkBillingItem(checkFor) {
    // console.log("checkFor", checkFor);
    // console.log("billingItem", billingItem);
    const hasSome =
      billingItem &&
      billingItem.length > 0 &&
      checkFor.some((item) => billingItem.includes(item));
    // console.log("hasSome", hasSome);
    return hasSome;
  }
  const externalURL = "https://www.dotworksoftware.com/terms-of-service";
  const externalURLforpp = "https://www.dotworksoftware.com/privacy-policy";
  const d = new Date();
  let year = d.getFullYear();
  return (
    <>
      <div className={miniActive + " sidebar"}>
        {loading && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <div className="sidebar-header">
          {userType !== null && userType.toUpperCase() === message.ACCTOWNER && (
            <NavLink
              to="/artwork"
              className="nav-link"
              activeClassName="active"
            >
              <img src={Logo} alt="" style={{ marginLeft: "32px" }} />
            </NavLink>
          )}
          {userType !== null && userType.toUpperCase() === message.VENDOR && (
            <NavLink
              to="/artwork"
              className="nav-link"
              activeClassName="active"
            >
              <img src={Logo} alt="" style={{ marginLeft: "32px" }} />
            </NavLink>
          )}
          {userType !== null && userType.toUpperCase() === message.ADMIN && (
            <NavLink
              to="/RegistrationRequests"
              className="nav-link"
              activeClassName="active"
            >
              <img src={Logo} alt="" style={{ marginLeft: "32px" }} />
            </NavLink>
          )}
          {userType !== null && userType.toUpperCase() === message.BUYER && (
            <NavLink
              to="/artwork"
              className="nav-link"
              activeClassName="active"
            >
              <img src={Logo} alt="" style={{ marginLeft: "32px" }} />
            </NavLink>
          )}
        </div>
        <div className="sidebar-content">
          {userType !== null && userType.toUpperCase() === message.ACCTOWNER && (
            <Nav defaultActiveKey="/home" className="flex-column">
              {/* <Nav.Item className="hide-767">
                <NavLink
                  to="/dashboard"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Dashboard />
                  </span>
                  <span className="side-label">Dashboard</span>
                </NavLink>
              </Nav.Item> */}
              <Nav.Item>
                <NavLink
                  to="/quickAppointment"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <EventAvailable />
                  </span>
                  <span className="side-label">Quick Appointment</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/artwork"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <AccessTime />
                  </span>
                  <span className="side-label">Artworks</span>
                </NavLink>
              </Nav.Item>
              {/* <Nav.Item className="hide-767">
              <NavLink
                to="/taskCalendar"
                className="nav-link"
                activeClassName="active"
              >
                <span className="side-icn">
                  <Today />
                </span>
                <span className="side-label">Calendar</span>
              </NavLink>
            </Nav.Item> */}
              <Nav.Item>
                <NavLink
                  to="/calendar"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Today />
                  </span>
                  <span className="side-label">Appointments</span>
                </NavLink>
              </Nav.Item>

              {/* <Nav.Item>
                <NavLink
                  to="/appointmentsCalendar"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Today />
                  </span>
                  <span className="side-label">Appointments New</span>
                </NavLink>
              </Nav.Item> */}

              <Nav.Item>
                <NavLink
                  to="/contacts"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Palette />
                  </span>
                  <span className="side-label">Artists</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/clients"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Portrait />
                  </span>
                  <span className="side-label">Clients</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/contactsPermissions"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <ManageAccounts />
                  </span>
                  <span className="side-label">Artists Permissions</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/MasterCampaign"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Subtitles />
                  </span>
                  <span className="side-label">Master Campaigns</span>
                </NavLink>
              </Nav.Item>

              {/* {checkBillingItem([message.aiimagetool]) ? ( */}
              <Nav.Item>
                <NavLink
                  // to="/generateImage"
                  to="#"
                  className="nav-link"
                  // activeClassName="active"
                  activeClassName={`nav-link ${
                    location.pathname === "/generateImage" ? "active" : ""
                  }`}
                  onClick={handleNavClick}
                >
                  <span className="side-icn">
                    <AcUnitRounded />
                  </span>
                  <span className="side-label">AI Image Generator</span>
                </NavLink>
              </Nav.Item>
              {/* ) : (
                ""
              )} */}

              {/* <Nav.Item>
              <NavLink
                to="/imageVariation"
                className="nav-link"
                activeClassName="active"
              >
                <span className="side-icn">
                  <EventAvailable />
                </span>
                <span className="side-label">Genrate image variations</span>
              </NavLink>
            </Nav.Item> */}
              {/* <Nav.Item>
              <NavLink
                to="/editImageAi"
                className="nav-link"
                activeClassName="active"
              >
                <span className="side-icn">
                  <EventAvailable />
                </span>
                <span className="side-label">Edit image Ai</span>
              </NavLink>
            </Nav.Item> */}
              <Nav.Item>
                <NavLink
                  to="/pathway"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Subtitles />
                  </span>
                  <span className="side-label">Pathways</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/financereports"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <AttachMoney />
                  </span>
                  <span className="side-label">Finance Reports</span>
                </NavLink>
              </Nav.Item>
              {/* <Nav.Item>
                <NavLink
                  to="/settings"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Settings />
                  </span>
                  <span className="side-label">Settings</span>
                </NavLink>
              </Nav.Item> */}
              <Nav.Item className="has-sublinks">
                <Accordion defaultexpanded="true" className="sublinks-inner">
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    className="nav-link sublinks-accordion mt-3"
                    id="panel1a-header"
                  >
                    <span className="side-icn">
                      <Description />
                    </span>
                    <span className="side-label">Forms</span>
                    <span className="sublinks-arrow" />
                  </AccordionSummary>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <NavLink
                        to="/intake"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Intake</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <NavLink
                        to="/consent"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Consent</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <NavLink
                        to="/clientSummary"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Client Summary</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <NavLink
                        to="/aftercare"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Aftercare</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <NavLink
                        to="/checkin"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Check-In</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                </Accordion>
              </Nav.Item>

              <Nav.Item className="has-sublinks">
                <Accordion defaultexpanded="true" className="sublinks-inner">
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    className="nav-link sublinks-accordion mt-3"
                    id="panel1a-header"
                  >
                    <span className="side-icn">
                      <Policy />
                    </span>
                    <span className="side-label">LEGAL</span>
                    <span className="sublinks-arrow" />
                  </AccordionSummary>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <Link
                        className="nav-link"
                        activeClassName="active"
                        target="_blank"
                        variants={"Link"}
                      >
                        {/* <span className="side-icn">
                        <AttachMoney />
                      </span> */}
                        <span className="side-circle" />
                        <span className="side-label">
                          <a
                            href={externalURL}
                            activeClassName="active"
                            className="nav-link"
                            target="_blank"
                          >
                            Terms of services
                          </a>
                        </span>
                      </Link>
                    </Nav.Item>
                  </AccordionDetails>

                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <Link
                        className="nav-link"
                        activeClassName="active"
                        target="_blank"
                        variants={"Link"}
                      >
                        {/* <span className="side-icn">
                        <AttachMoney />
                      </span> */}
                        <span className="side-circle" />
                        <span className="side-label">
                          <a
                            href={externalURLforpp}
                            activeClassName="active"
                            className="nav-link"
                            target="_blank"
                          >
                            Privacy Policy
                          </a>
                        </span>
                      </Link>
                    </Nav.Item>
                  </AccordionDetails>
                </Accordion>
              </Nav.Item>
            </Nav>
          )}

          {userType !== null && userType.toUpperCase() === message.ADMIN && (
            <Nav defaultActiveKey="/home" className="flex-column">
              <Nav.Item>
                <NavLink
                  to="/RegistrationRequests"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Assignment />
                  </span>
                  <span className="side-label">Registration Requests</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/AccountOwner"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <ContactMail />
                  </span>
                  <span className="side-label">Studio Owners</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/Vendors"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Palette />
                  </span>
                  <span className="side-label">Artists</span>
                </NavLink>
              </Nav.Item>
              {/* <Nav.Item>
                <NavLink
                  to="/Buyers"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <AccountBox />
                  </span>
                  <span className="side-label">Clients</span>
                </NavLink>
              </Nav.Item> */}

              <Nav.Item className="hide-767 has-sublinks">
                <Accordion defaultExpanded={true} className="sublinks-inner">
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    className="nav-link sublinks-accordion"
                    id="panel1a-header"
                  >
                    <span className="side-icn">
                      <CreditCard />
                    </span>
                    <span className="side-label">Billing Module</span>
                    <span className="sublinks-arrow" />
                  </AccordionSummary>

                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/BillingModule/BillingItems"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Billing Items</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>

                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/BillingModule/BillingPlansList"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Billing Plans</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>

                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/BillingModule/BillingHistory"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Billing History</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                </Accordion>
              </Nav.Item>
              <Nav.Item className="hide-767">
                <NavLink
                  to="/MasterTemplate"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Subtitles />
                  </span>
                  <span className="side-label">Master Templates</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item className="hide-767">
                <NavLink
                  to="/AdminPathway"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Subtitles />
                  </span>
                  <span className="side-label">Pathways</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/financereports"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <AttachMoney />
                  </span>
                  <span className="side-label">Finance Reports</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item className="hide-767">
                <NavLink
                  to="/AdminUsers"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <SupervisedUserCircle />
                  </span>
                  <span className="side-label">Admin Users</span>
                </NavLink>
              </Nav.Item>
              {/* {localStorage.getItem(code.IS_STRIPE_ENABLED) === "true" ? (
                <Nav.Item className="hide-767">
                  <NavLink
                    to="/Subscription"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <span className="side-icn">
                      <CardMembership />
                    </span>
                    <span className="side-label">Subscription</span>
                  </NavLink>
                </Nav.Item>
              ) : (
                ""
              )} */}
              {/* <Nav.Item className="hide-767">
              <NavLink
                to="/Report"
                className="nav-link"
                activeClassName="active"
              >
                <span className="side-icn">
                  <Assessment />
                </span>
                <span className="side-label">Usage Report</span>
              </NavLink>
            </Nav.Item> */}

              {/* <Nav.Item className="hide-767 has-sublinks">
              <Accordion defaultExpanded={true} className="sublinks-inner">
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  className="nav-link sublinks-accordion"
                  id="panel1a-header"
                >
                  <span className="side-icn">
                    <AcUnitRounded />
                  </span>
                  <span className="side-label">AI Module</span>
                  <span className="sublinks-arrow" />
                </AccordionSummary>
                <AccordionDetails className="sublinks">
                  <Nav.Item className="hide-767">
                    <NavLink
                      to="/AiPrompt"
                      className="nav-link"
                      activeClassName="active"
                    >
                      <span className="side-circle" />
                      <span className="side-label">AI Prompt</span>
                    </NavLink>
                  </Nav.Item>
                </AccordionDetails>
                <AccordionDetails className="sublinks">
                  <Nav.Item className="hide-767">
                    <NavLink
                      to="/AiVersions"
                      className="nav-link"
                      activeClassName="active"
                    >
                      <span className="side-circle" />
                      <span className="side-label">AI Versions</span>
                    </NavLink>
                  </Nav.Item>
                </AccordionDetails>
              </Accordion>
            </Nav.Item> */}

              <Nav.Item className="hide-767 has-sublinks">
                <Accordion defaultExpanded={true} className="sublinks-inner">
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    className="nav-link sublinks-accordion"
                    id="panel1a-header"
                  >
                    <span className="side-icn">
                      <CreditCard />
                    </span>
                    <span className="side-label">Ai Module</span>
                    <span className="sublinks-arrow" />
                  </AccordionSummary>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/AiCategorySubCategoryList"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">AI Categories</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/AiPromptsListing"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">AI Prompts</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/AiVersions"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Ai Versions</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>

                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/AssignVersion"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Assign Version</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                </Accordion>
              </Nav.Item>

              <Nav.Item className="hide-767 has-sublinks">
                <Accordion defaultexpanded="true" className="sublinks-inner">
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    className="nav-link sublinks-accordion"
                    id="panel1a-header"
                  >
                    <span className="side-icn">
                      <Equalizer />
                    </span>
                    <span className="side-label">Master Data</span>
                    <span className="sublinks-arrow" />
                  </AccordionSummary>
                  {/* <AccordionDetails className="sublinks">
                  <Nav.Item className="hide-767">
                    <NavLink
                      to="/ManageData"
                      className="nav-link"
                      activeClassName="active"
                    >
                      <span className="side-circle" />
                      <span className="side-label">Lead Source</span>
                    </NavLink>
                  </Nav.Item>
                </AccordionDetails> */}
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/emails"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Email Templates</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/contingencies"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Contingencies</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/roles"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Roles</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/hearAboutUs"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Hear About Us</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/transactionType"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Transaction Type</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/systemBanners"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">System Banners</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>

                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/systemVersions"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">System Versions</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item className="hide-767">
                      <NavLink
                        to="/lookupmasterdata"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Lookup Master Data</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                </Accordion>
              </Nav.Item>

              <Nav.Item className="has-sublinks">
                <Accordion defaultexpanded="true" className="sublinks-inner">
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    className="nav-link sublinks-accordion mt-3"
                    id="panel1a-header"
                  >
                    <span className="side-icn">
                      <Policy />
                    </span>
                    <span className="side-label">LEGAL</span>
                    <span className="sublinks-arrow" />
                  </AccordionSummary>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <Link
                        className="nav-link"
                        activeClassName="active"
                        target="_blank"
                        variants={"Link"}
                      >
                        {/* <span className="side-icn">
                        <AttachMoney />
                      </span> */}
                        <span className="side-circle" />
                        <span className="side-label">
                          <a
                            href={externalURL}
                            activeClassName="active"
                            className="nav-link"
                            target="_blank"
                          >
                            Terms of services
                          </a>
                        </span>
                      </Link>
                    </Nav.Item>
                  </AccordionDetails>

                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <Link
                        className="nav-link"
                        activeClassName="active"
                        target="_blank"
                        variants={"Link"}
                      >
                        {/* <span className="side-icn">
                        <AttachMoney />
                      </span> */}
                        <span className="side-circle" />
                        <span className="side-label">
                          <a
                            href={externalURLforpp}
                            activeClassName="active"
                            className="nav-link"
                            target="_blank"
                          >
                            Privacy Policy
                          </a>
                        </span>
                      </Link>
                    </Nav.Item>
                  </AccordionDetails>
                </Accordion>
              </Nav.Item>
            </Nav>
          )}

          {userType !== null && userType.toUpperCase() === message.VENDOR && (
            <Nav defaultActiveKey="/home" className="flex-column">
              {vendorRoleName === "Artist" &&
              checkPermission([message.manage_quick_appointment]) ? (
                <Nav.Item className="hide-767">
                  <NavLink
                    to="/quickAppointment"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <span className="side-icn">
                      <EventAvailable />
                    </span>
                    <span className="side-label">Quick Appointment</span>
                  </NavLink>
                </Nav.Item>
              ) : (
                ""
              )}
              <Nav.Item>
                <NavLink
                  to="/artwork"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Home />
                  </span>
                  <span className="side-label">Artworks</span>
                </NavLink>
              </Nav.Item>

                <Nav.Item>
                  <NavLink
                    to="/generateImage"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <span className="side-icn">
                      <AcUnitRounded />
                    </span>
                    <span className="side-label">AI Image Generator</span>
                  </NavLink>
                </Nav.Item>

              {/* <Nav.Item className="hide-767">
              <NavLink
                to="/taskCalendar"
                className="nav-link"
                activeClassName="active"
              >
                <span className="side-icn">
                  <Today />
                </span>
                <span className="side-label">Calendar</span>
              </NavLink>
            </Nav.Item> */}
              <Nav.Item>
                <NavLink
                  to="/calendar"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Today />
                  </span>
                  <span className="side-label">Appointments</span>
                </NavLink>
              </Nav.Item>

              {/* <Nav.Item className="hide-767">
                <NavLink
                  to="/calendar"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Today />
                  </span>
                  <span className="side-label">Appointments New</span>
                </NavLink>
              </Nav.Item> */}

              {vendorRoleName === "Artist" &&
              checkPermission([
                message.manage_contact,
                message.view_contact,
              ]) ? (
                <Nav.Item>
                  <NavLink
                    to="/contacts"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <span className="side-icn">
                      <Palette />
                    </span>
                    <span className="side-label">Artists</span>
                  </NavLink>
                </Nav.Item>
              ) : (
                ""
              )}
              {vendorRoleName === "Artist" &&
              checkPermission([
                message.manage_client,
                message.view_client,
              ]) ? (
                <Nav.Item>
                  <NavLink
                    to="/clients"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <span className="side-icn">
                      <Portrait />
                    </span>
                    <span className="side-label">Clients</span>
                  </NavLink>
                </Nav.Item>
              ) : (
                ""
              )}
              {vendorRoleName === "Artist" &&
              checkPermission([
                message.view_permission_contact,
                message.manage_permission_contact,
              ]) ? (
                <Nav.Item>
                  <NavLink
                    to="/contactsPermissions"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <span className="side-icn">
                      <ManageAccounts />
                    </span>
                    <span className="side-label">Artists Permissions</span>
                  </NavLink>
                </Nav.Item>
              ) : (
                ""
              )}

              {vendorRoleName === "Artist" &&
              checkPermission([
                message.view_master_campaign,
                message.manage_master_campaign,
              ]) ? (
                <Nav.Item className="hide-767">
                  <NavLink
                    to="/MasterCampaign"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <span className="side-icn">
                      <Subtitles />
                    </span>
                    <span className="side-label">Master Campaigns</span>
                  </NavLink>
                </Nav.Item>
              ) : (
                ""
              )}
              {vendorRoleName === "Artist" &&
              checkPermission([
                message.view_pathway,
                message.manage_pathway,
              ]) ? (
                <Nav.Item className="hide-767">
                  <NavLink
                    to="/pathway"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <span className="side-icn">
                      <Subtitles />
                    </span>
                    <span className="side-label">Pathways</span>
                  </NavLink>
                </Nav.Item>
              ) : (
                ""
              )}
              {/* <Nav.Item>
                <NavLink
                  to="/clients"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Portrait />
                  </span>
                  <span className="side-label">Clients</span>
                </NavLink>
              </Nav.Item> */}

              {vendorRoleName === "Artist" ? (
                <Nav.Item className="has-sublinks">
                  <Accordion
                    defaultexpanded="true"
                    className="sublinks-inner"
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1a-content"
                      className="nav-link sublinks-accordion"
                      id="panel1a-header"
                    >
                      <span className="side-icn">
                        <Description />
                      </span>
                      <span className="side-label">Forms</span>
                      <span className="sublinks-arrow" />
                    </AccordionSummary>
                    <AccordionDetails className="sublinks">
                      <Nav.Item>
                        <NavLink
                          to="/intake"
                          className="nav-link"
                          activeClassName="active"
                        >
                          <span className="side-circle" />
                          <span className="side-label">Intake</span>
                        </NavLink>
                      </Nav.Item>
                    </AccordionDetails>
                    <AccordionDetails className="sublinks">
                      <Nav.Item>
                        <NavLink
                          to="/consent"
                          className="nav-link"
                          activeClassName="active"
                        >
                          <span className="side-circle" />
                          <span className="side-label">Consent</span>
                        </NavLink>
                      </Nav.Item>
                    </AccordionDetails>
                    <AccordionDetails className="sublinks">
                      <Nav.Item>
                        <NavLink
                          to="/clientSummary"
                          className="nav-link"
                          activeClassName="active"
                        >
                          <span className="side-circle" />
                          <span className="side-label">Client Summary</span>
                        </NavLink>
                      </Nav.Item>
                    </AccordionDetails>
                    <AccordionDetails className="sublinks">
                      <Nav.Item>
                        <NavLink
                          to="/aftercare"
                          className="nav-link"
                          activeClassName="active"
                        >
                          <span className="side-circle" />
                          <span className="side-label">Aftercare</span>
                        </NavLink>
                      </Nav.Item>
                    </AccordionDetails>
                    <AccordionDetails className="sublinks">
                      <Nav.Item>
                        <NavLink
                          to="/checkin"
                          className="nav-link"
                          activeClassName="active"
                        >
                          <span className="side-circle" />
                          <span className="side-label">Check-In</span>
                        </NavLink>
                      </Nav.Item>
                    </AccordionDetails>
                  </Accordion>
                </Nav.Item>
              ) : (
                ""
              )}

              <Nav.Item className="has-sublinks">
                <Accordion defaultexpanded="true" className="sublinks-inner">
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    className="nav-link sublinks-accordion mt-3"
                    id="panel1a-header"
                  >
                    <span className="side-icn">
                      <Policy />
                    </span>
                    <span className="side-label">LEGAL</span>
                    <span className="sublinks-arrow" />
                  </AccordionSummary>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <Link
                        className="nav-link"
                        activeClassName="active"
                        target="_blank"
                        variants={"Link"}
                      >
                        {/* <span className="side-icn">
                        <AttachMoney />
                      </span> */}
                        <span className="side-circle" />
                        <span className="side-label">
                          <a
                            href={externalURL}
                            activeClassName="active"
                            className="nav-link"
                            target="_blank"
                          >
                            Terms of services
                          </a>
                        </span>
                      </Link>
                    </Nav.Item>
                  </AccordionDetails>

                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <Link
                        className="nav-link"
                        activeClassName="active"
                        target="_blank"
                        variants={"Link"}
                      >
                        {/* <span className="side-icn">
                        <AttachMoney />
                      </span> */}
                        <span className="side-circle" />
                        <span className="side-label">
                          <a
                            href={externalURLforpp}
                            activeClassName="active"
                            className="nav-link"
                            target="_blank"
                          >
                            Privacy Policy
                          </a>
                        </span>
                      </Link>
                    </Nav.Item>
                  </AccordionDetails>
                </Accordion>
              </Nav.Item>
            </Nav>
          )}

          {userType !== null && userType.toUpperCase() === message.BUYER && (
            <Nav defaultActiveKey="/home" className="flex-column">
              <Nav.Item>
                <NavLink
                  to="/artwork"
                  className="nav-link"
                  activeClassName="active"
                >
                  <span className="side-icn">
                    <Home />
                  </span>
                  <span className="side-label">Transactions</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item className="has-sublinks">
                <Accordion defaultexpanded="true" className="sublinks-inner">
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    className="nav-link sublinks-accordion mt-3"
                    id="panel1a-header"
                  >
                    <span className="side-icn">
                      <Description />
                    </span>
                    <span className="side-label">Forms</span>
                    <span className="sublinks-arrow" />
                  </AccordionSummary>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <NavLink
                        to="/intake"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Intake</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <NavLink
                        to="/consent"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Consent</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                  <AccordionDetails className="sublinks">
                    <Nav.Item>
                      <NavLink
                        to="/aftercare"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <span className="side-circle" />
                        <span className="side-label">Aftercare</span>
                      </NavLink>
                    </Nav.Item>
                  </AccordionDetails>
                </Accordion>
              </Nav.Item>
            </Nav>
          )}
          {/* <Nav defaultActiveKey="/home" className="flex-column">
            <Nav.Item>

              <a href={urls.tellagentSupportBaseUrl} class = "nav-link" target="_blank">
                <span className="side-icn">
                  <ContactSupport />
                </span>
                <span className="side-label">Support</span>
              </a>
            </Nav.Item>
          </Nav> */}
        </div>
        <div className="ftr-cont py-3 px-4 " style={{ fontSize: "11px" }}>
          <span>© {year} DotWork. All Rights Reserved.</span>

          <div className="text-center d-flex align-items-center mt-1">
            <span className="mr-3">
              <a
                href={link}
                activeClassName="active"
                style={{ color: "white" }}
                target="_blank"
              >
                Version - {version}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    renderSidebar: state.reducer.renderSidebar,
    renderHeader: state.reducer.renderHeader,
  };
};

export default connect(
  mapStateToProps,
  {
    getallpermissions,
    setRenderHeader,
    getBillingItemForpermissions,
    getCurrentSystemVersionAction,
  }
)(Sidebar);
